<div class="inner-content">
  <div class="div_content">
    <h2 class="title">Elige el motivo del rechazo</h2>
  </div>
  <div class="content">
    <ion-item>
      <ion-label>Motivo</ion-label>
      <!--
        Los motivos salen de la coleccion `rejectOrder`, la misma que usa mitter-panel.
        El valor guardado es el `name` del documento, que el panel usa como clave de
        traduccion al mostrarlo: por eso aca tambien se traduce en vez de pintarlo crudo.
      -->
      <ion-select [(ngModel)]="reason" mode="ios">
        <ion-select-option *ngFor="let motivo of reasons" [value]="motivo.name">
          {{ label(motivo) }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <!-- Textarea in an item with a floating label -->
    <ion-item>
      <ion-label position="floating">Detalla el motivo del rechazo</ion-label>
      <ion-textarea autofocus="true" [(ngModel)]="detail"></ion-textarea>
    </ion-item>
  </div>
  <div class="div_btn">
    <ion-button class="btn_cancel" (click)="close()" fill="outline"> {{'Cancel' | translate}} </ion-button>
    <ion-button class="btn_confirm" (click)="select()"> {{'Select' | translate}} </ion-button>
  </div>
</div>
